import { render, staticRenderFns } from "./productivity-hacks-a45.vue?vue&type=template&id=3d72f246&"
import script from "./productivity-hacks-a45.vue?vue&type=script&lang=js&"
export * from "./productivity-hacks-a45.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports